      import StatisticsCards from '@common-components/cards/StatisticsCards'
import StatisticsFilters from '@common-components/statistics-filters/StatisticsFilters'
import StatisticsSummary from '@common-components/Statistics-total-summary/StatisticsSummary'
import { useFetch } from '@hooks/useBatchIntakeApi';
import INTAKE_API from 'api/intakeApi';
import React, { useEffect, useState } from 'react'

export default function Statistics() {
    const [selectSupplier, setSelectSupplier] = useState(null);
    const { data: suppliers, isLoading: isSuppliersLoading } = useFetch("getSuppliers", INTAKE_API.getSuppliers, { PageNo: 0, PageSize: 1000 });
  const [batchData, setBatchData] = useState(null);
  const [supplierName, setSupplierName] = useState(null);
    const [selectBatch, setSelectBatch] = useState(null);
    useEffect(() => {
        const supplierId = localStorage.getItem('supplierId');

        if (supplierId) {
            setSelectSupplier(supplierId);
        }

    }, [])


    return (
        <>
            <StatisticsFilters supplierName = {supplierName} setSupplierName = {setSupplierName} setBatchData = {setBatchData} suppliers={suppliers} selectSupplier={selectSupplier} setSelectSupplier={setSelectSupplier} setSelectBatch={setSelectBatch} selectBatch={selectBatch} />
            <StatisticsCards setBatchData = {setBatchData} supplierName = {supplierName} batchData = {batchData}   supplierID={selectSupplier} />
            <StatisticsSummary supplierId={selectSupplier} batchNum={selectBatch} />
        </>
    )
}
